module.exports = __webpack_public_path__ + "static/media/YM05_1.92fa4e50.jpg";